import React, { useState, useEffect } from "react";
import { dateFormator, mapTableRows } from "../../../../../utils";
import {
  Backdrop,
  Button,
  Divider,
  Modal,
  DocumentsList,
  LogoLoader,
  PageHeader,
  PageTitle,
  TableAdv,
} from "../../../../../components";
import { useDispatch, useSelector } from "react-redux";
import {
  clearPlacementsData,
  getAllPlacementsStart,
} from "../../../../../redux/slices/placements/placementsSlice";
import dayjs from "dayjs";
import { ENDPOINTS } from "../../../../../redux/apiConfig";
import axiosRequest from "../../../../../redux/slices/universal/axiosService";

const Inactive = ({ vendorId }) => {
  const dispatch = useDispatch();
  const { placements: placementsTableData, isLoading } = useSelector(
    (state) => state?.placement
  );

  const [selectedDocuments, setSelectedDocuments] = useState([]);
    const [linked, setLinked] = useState([]);
  

  useEffect(() => {
    if (vendorId) {
      dispatch(
        getAllPlacementsStart({
          fil: {
            "vendor.id":{type: "NONE", value: vendorId},
            // entityId: { type: "NONE", value: vendorId },
            // "jobInfo.entityType": { type: "NONE", value: "Vendor" },
          "jobInfo.endDate": { type: "LT", value: dayjs().startOf("day") },
          },
          ref: "Employee Vendor",
          incl: ["firstName lastName employmentType"],
        })
      );
    }
    return () => {
      dispatch(clearPlacementsData());
    };
  }, [vendorId]);

  const EmploymentType = {
    1: "Regular",
    2: "Consultant",
    3: "Contractor",
  };

const tableData2 = Array.from(
  new Map(
    placementsTableData?.data?.map((item) => [
      item.uiid,
      {
        uiid: item.uiid,
        consultantName: `${item?.employeeId?.firstName || ""} ${item?.employeeId?.lastName || ""}`,
        consultantType: EmploymentType[item?.employeeId?.employmentType] || "Employee",
        jobTitle: item?.jobInfo?.jobTitle || "-",
        jobCode: item?.jobInfo?.jobCode || "-",
        vendor: item?.vendor?.id?.businessName || "-",
        startDate: item?.jobInfo?.startDate || "-",
        endDate: item?.jobInfo?.endDate || "-",
        poNumber: item?.payments?.[0]?.poNum ? `PO# ${item?.payments[0].poNum}` : "-",
        poLink: item?.payments?.flatMap((payment) => payment?.poLink || []),
      },
    ])
  ).values()
);

  const tableData = [
    {
      consultantName: "Ravindra Rao ",
      consultantType: "Employee",
      jobTitle: "IBM BPM Developer_NET Esolutions",
      jobCode: "NETE-001",
      vendor: "--",
      startDate: "2019-02-01T18:30:00.000Z",
      endDate: "2025-12-30T18:30:00.000Z",
      poNumber: "PO# N-240051",
    },
    {
      consultantName: "Chandra Gundu",
      consultantType: "Contract",
      jobTitle: "Sr. Net Developer",
      jobCode: "NDSFL-002",
      vendor: "RAMPS International Inc",
      startDate: "2022-10-06T18:30:00.000Z",
      endDate: "2025-12-30T18:30:00.000Z",
      poNumber: "PO# N-240051",
    },
  ];
  const columns = [
    {
      key: "consultantName",
      label: "Consultant Name",
    },

    {
      key: "consultantType",
      label: "Consultant Type",
    },
    {
      key: "jobTitle",
      label: "Job Title",
      width: "min-w-[250px]! max-w-[300px]!",
    },
    {
      key: "jobCode",
      label: "Job Code",
    },
    {
      key: "vendor",
      label: "Vendor",
      width: "min-w-[250px]! max-w-[300px]!",
    },
    {
      key: "startDate",
      label: "Start Date",
      render: (row) => dateFormator(row.startDate, "month-day-year"),
    },
    {
      key: "endDate",
      label: "End Date",
      render: (row) => dateFormator(row.endDate, "month-day-year"),
    },
    {
      key: "poNumber",
      label: "PO Number",
    },

    {
      key: "purchaseOrder",
      label: "Purchase Order",
      render: (row) => (
        <div className="flex items-center">
          <Button
            type="icon"
            variant="text"
            icon={"download"}
            color="black"
            size="sm"
            onClick={() =>
              setSelectedDocuments(
                row.poLink.map((item) => ({
                  filePath: item,
                  name: row?.poNumber || "-",
                }))
              )
            }
          />
          <Button
            type="icon"
            variant="text"
            icon={"history"}
            color="black"
            size="sm"
          />
        </div>
      ),
    },
  ];

  // const mappedRows = mapTableRows(tableData, columns);
  const mappedRows = mapTableRows(tableData2, columns);
  const linkedplacementTableData = [
    // {
    //   consultantName: "LaTara Leshica",
    //   consultantType: "Electronics Technician Level 2",
    //   jobTitle: "FE001",
    //   billableClient: "Freedom Electronics",
    //   linkedAs: "End Client",
    //   placementType: "Permanent Placement",
    // },
  ];
  const linkedplacementColumns = [
    {
      key: "consultantName",
      label: "Consultant Name",
    },

    {
      key: "consultantType",
      label: "Consultant Type",
    },
    {
      key: "jobTitle",
      label: "Job Title",
      width: "min-w-[250px]! max-w-[300px]!",
    },
    {
      key: "billableClient",
      label: "Billable Client",
    },
    {
      key: "linkedAs",
      label: "Linked As",
    },
    {
      key: "placementType",
      label: "Placement Type",
    },
  ];
  const ConsultantType = {
    1: "Employee",
    2: "Consultant",
    3: "Contractor",
  };
  const mappedLinkedData =
    linked.length > 0
      ? (linked || [])?.map((row, i) => ({
          consultantName: [row?.employeeId?.firstName, row?.employeeId?.lastName].filter(Boolean).join(" ") || '-',
          consultantType:
            ConsultantType[row?.employeeId?.employmentType] || "-",
          jobTitle: row?.jobInfo?.jobTitle || "-",
          billableClient: (row?.jobInfo?.billClient?.businessName || row?.jobInfo?.billClient  ) || "-",
          linkedAs: "Referral" || "-",
          placementType: row?.clientPlacement?.placement || "-",
        }))
      : [];
  const linkedplacementmappedRows = mapTableRows(
    // linkedplacementTableData,
    mappedLinkedData,
    linkedplacementColumns
  );
  useEffect(() => {
    const fetchLinkedPlacements = async () => {
      let filter = {
        // uiid: {
        //   type: "NONE",
        //   value: vendorId,
        // },
        vendorId: { type: "AG_REFERRAL", value:  ["Inactive", vendorId] },
      };
      const response = await axiosRequest({
        method: "GET",
        url: ENDPOINTS.PLACEMENTS.GET_ALL,
        params: {
          lim: 100,
          pg: 1,
          coll: "Placement",
          fil: JSON.stringify(filter),
          useAggregate:true,
          // se
          ret:"jobInfo.billClient.businessName jobInfo.endDate jobInfo.jobTitle clientPlacement.placement employeeId.firstName employeeId.lastName employeeId.uiid employeeId.employmentType",
          ref: "Employee",
        },
      });
      console.log(
        "response active placement linked",
        response?.data?.data
      );
      setLinked(response?.data?.data || []);
    };
    fetchLinkedPlacements();
  }, []);

  return (
    <>
      <Modal
        isOpen={selectedDocuments.length > 0}
        onClose={() => setSelectedDocuments([])}
        width="max-w-2xl"
        title={"Document Details"}
      >
        <DocumentsList data={selectedDocuments} />
      </Modal>
      <Backdrop isOpen={isLoading}>
        <LogoLoader />
      </Backdrop>
      <div className="py-3 ">
        <TableAdv tableId={`vendors_placements_inactive`} columns={columns} rows={mappedRows} hideToolBar />
        <div className="mt-4">
          <PageHeader
            Section={
              <div className="flex">
                <PageTitle title={"LINKED PLACEMENTS "} tag="p" />
              </div>
            }
          />
        </div>
        <Divider className="mb-3" />
        <TableAdv
          tableId={`vendors_placements_inactive_linkedplacements`}
          columns={linkedplacementColumns}
          rows={linkedplacementmappedRows}
          hideToolBar
        />
        <div className="mt-4">
          <PageHeader
            Section={
              <div className="flex">
                <PageTitle title={"ACTIVITIES"} tag="p" />
              </div>
            }
          />
        </div>
        <Divider className="mb-3" />
      </div>
    </>
  );
};

export default Inactive;
